import React, { useLayoutEffect, useEffect, useState, useRef } from 'react'
import { CSSTransition } from 'react-transition-group'
import classNames from 'classnames'
import { Button, IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons';
import * as defs from './Modal.module.scss'
// import useLockBodyScroll from '../useLockBodyScroll.hook'
// import { disableBodyScroll, enableBodyScroll } from '../../utils/bodyScrollLock'

const Modal = props => {

  const [shown, setShown] = useState(false);

  // useLayoutEffect(() => {
  //   disableBodyScroll(nodeRef)
  //   setShown(true)
  //   return () => {
  //     enableBodyScroll(nodeRef)
  //     setShown(false)
  //   };
  // }, [])
  
  const {
    className: passedClasses = null,
    children,
    dismissable = true,
    onClose,
    show
  } = props


  useEffect(() => {
    if (show) setShown(true);
    if (!show) setShown(false);
  }, [show]);

  const onClick = e => {
    if (dismissable && e.target.className === defs.modal) {
      onClose()
    }
  }

  const baseClasses = { [passedClasses]: !!passedClasses }
  const modalClasses = classNames({...baseClasses, [defs.modal]: true})
  const backdropClasses = classNames({...baseClasses, [defs.backdrop]: true})
  const contentClasses = classNames({...baseClasses, [defs.content]: true})

  // const nodeRef = useRef(null)

  return (
    <CSSTransition in={shown} key='modal-transition' appear unmountOnExit  timeout={{enter: 200, exit: 150}} className='modal-popup'> 
      <div>
        <div className={backdropClasses} />
        <div className={modalClasses} onClick={onClick} >
          <div style={{padding: '16px', position: 'relative'}} className={contentClasses}>
          <IconButton onClick={onClose} style={{padding: '3px', right: '14px', top: '22px', position: 'absolute'}}><Close style={{fontSize:'16px'}} /></IconButton>
            {children}
          </div>
        </div> 
      </div>
    </CSSTransition>
  )

}

export default Modal